import { Button } from 'react-bootstrap';
import flecha_abajo from 'assets/img/flecha_abajo.png';
import { useHistory } from 'react-router-dom';

const MyGuestsButton = ({ botoninvitados }) => {
    const history = useHistory();

    const handleRedirectAgregaInvitados = () => {
        //  alert('Agregando invitados por separado');
        history.push('/agrega-invitados');
    };


    const handleDownloadClickListaConfirmados = (excelFilePath) => {
        const link = document.createElement('a');
        link.href = excelFilePath;
        link.click();
    };

    return (
        <div>
            {botoninvitados?.data?.items?.excel && (
                <>
                    <Button
                        id={1}
                        block
                        variant="secondary"
                        onClick={() => handleDownloadClickListaConfirmados(botoninvitados?.data?.items?.excelFilePath)}
                        type="button"
                        className={'btn-sm'}
                        style={{ fontSize: 'smaller' }}>
                        <i className='fa fa-download'></i> Descarga tu lista de confirmados
                    </Button>
                </>
            )}
            <Button
                id={2}
                block
                variant="secondary"
                onClick={handleRedirectAgregaInvitados}
                type="button"
                className={'btn-sm'}
                style={{ fontSize: 'smaller' }}
            >
                Agregar invitados por separado
            </Button>
        </div>
    );
}

export default MyGuestsButton;